import { render, staticRenderFns } from "./ExibirApenasCombinacoesSwitch.vue?vue&type=template&id=7685de7f"
import script from "./ExibirApenasCombinacoesSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ExibirApenasCombinacoesSwitch.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports